import commonRes from '../abstract.resource';
import {readService} from '../serializers/service.serializer';

const mod = angular.module('app.common.resources.service', [commonRes])

.factory('ServiceResource', function (AbstractResource, $http) {
  class ServiceResource extends AbstractResource {
    constructor() {
      super('services', ServiceResource.fromBackend, true);
    }

    /**
     * Get a single service by Podio ID.
     * @param {Number} podioId
     */
    getByPodioId(podioId) {
      return $http.get(
        AbstractResource.resolveUrl(this.url),
        {
          headers: this._headers,
          params: {podioId}
        })
      .then(response => {
        // Endpoint returns a list of services but should only contain 1.
        const data = response.data.map(obj => this.mapper(obj, {}));
        if (data.length === 1) {
          return data[0];
        }
        else {
          throw new Error(`could not find valid services with id ${podioId}`);
        }
      });
    }

    /**
     * Parse a service retrieved from the backend.
     * @param {Object} o
     * @returns {Service}
     */
    static fromBackend(o) {
      return readService(o).makeImmutable();
    }
  }

  return new ServiceResource();
});

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/common/resources/service.resource.js